<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";
    import {decode, encode} from "../../../helpers";
    import DopMaterialList from "../../parts/DopMaterialList.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let fetched = await network.fetch_tovar(item.idTovar)
            let json = JSON.parse(decode(fetched.ind3))
            type = json.type
            fetchData = await fetch();


            width.set(json.width)
            height.set(json.height)

            t = json.t
            kolvobok = json.kolvobok
            tip = json.tip
            tkan = json.tkan
            begunki = json.begunki
            await filterCorniceOptions();
            setTimeout(() => tkan2 = json.tkan2, 200)

            tkanboka = json.tkanboka
            await filterCorniceOptions2();
            setTimeout(() => tkanboka2 = json.tkanboka2, 250)
            arca = json.arca
            arcaVisotaBoka = json.arcaVisotaBoka
            arcaVisotaCentr = json.arcaVisotaCentr

            components = json.components
            count.set(+item.quantity);
            comment.set(item.comment);
            change();
        }
    };

    let components = {}

    const fetch = async () => {
        let result = await network.fetch_data('Вальс', type);
        //console.log('Raw result:', result); // <-- Добавь это
        let filtered2 = result.filter(el => el.name.includes('кв') && el.flag === '1')
        const validIds = new Set(filtered2.map(el => el.ind1.trim().toLowerCase()));
        // console.log('validIds', validIds); // <-- И это
        let filtered = result
            .filter(el => el.name.startsWith('Ткань ') && el.flag === '1')
            .filter(el => validIds.has(el.ind1.trim().toLowerCase())); // оставляем только те, что есть в filtered2
        // Создаем маппинг ткань -> доступные корнизы
        const tkanToCorniceMap = {};

        filtered.forEach(el => {
            const tkanName = el.ind1.trim().capitalize();
            const corniceName = el.ind2.trim().capitalize();

            if (!tkanToCorniceMap[tkanName]) {
                tkanToCorniceMap[tkanName] = new Set();
            }
            tkanToCorniceMap[tkanName].add(corniceName);
        });

        // Подготываем данные для селектов
        const colorTape = Array.from(new Set(filtered.map(el => el.ind1.trim().capitalize()))).filter(str => str !== '').sort((a, b) => a.localeCompare(b));
        const colorCornice = Array.from(new Set(filtered.map(el => el.ind2.trim().capitalize()))).filter(str => str !== '').sort((a, b) => a.localeCompare(b));

        //
        if (colorCornice.length && !colorCornice.includes(tkan)) {
            //      tkan = colorTape[0]
        }

        return {
            name: _.groupBy(result, 'name'),
            cloth: filtered,
            color_tape: colorTape,
            color_cornice: colorCornice,
            tkanToCorniceMap: tkanToCorniceMap, // Маппинг для фильтрации
            result,
        }
    }

    let
        width = parameter('width', '2000'),
        height = parameter('height', '2300'),

        ind2 = '101 (белый)', // цвет


        t = 'T1 (к упр)',
        kolvobok = 'нет',
        tip = 'ГИ Ручной лев',
        tkan = 'Полоса DT',
        tkan2 = 'DT-01',
        tkanboka = 'Полоса DT',
        tkanboka2 = 'DT-01',
        begunki = 'Пласт.бегунки',
        type = 'Вальс',
        arca = "Нет",
        arcaVisotaCentr = "Нет",
        arcaVisotaBoka = "Нет",


        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1),
        foto = ''
    ;

    let fetchData = fetch();
    let filteredCornice = []; // Отфильтрованные значения для второго селекта
    let filteredCornice2 = []; // Отфильтрованные значения для второго селекта
    /* let
         montage_item,
         montage_price = 1;*/

    // Инициализация отфильтрованных значений после загрузки данных
    const initializeFilteredValues = async () => {
        const data = await fetchData;

        if (data.color_cornice) {
            filteredCornice = [...data.color_cornice];
            filteredCornice2 = [...data.color_cornice];

            // Применяем фильтрацию если уже выбраны ткани
            if (tkan) {
                await filterCorniceOptions();
            }
            if (tkanboka) {
                await filterCorniceOptions2();
            }
        }
    };


    const changeType = () => {
        fetchData = fetch()
        filterCorniceOptions();
        filterCorniceOptions2();
        change();
    };

    // Обработчик изменения первой ткани
    const handleTkanChange = (event) => {
        tkan = event.target.value;
        filterCorniceOptions();
        change();
    };

    // Обработчик изменения второй ткани
    const handleTkan2Change = (event) => {
        tkanboka2 = event.target.value;
        filterCorniceOptions2();
        change();
    };

    // Фильтрация опций для второго селекта
    const filterCorniceOptions = async () => {
        const data = await fetchData;

        if (!tkan || !data.tkanToCorniceMap) {
            // Если ничего не выбрано, показываем все корнизы
            filteredCornice = data.color_cornice || [];
            return;
        }

        // Получаем доступные корнизы для выбранной ткани
        const availableCornices = data.tkanToCorniceMap[tkan] || new Set();

        // Фильтруем опции корнизы
        filteredCornice = (data.color_cornice || []).filter(cornice =>
            availableCornices.has(cornice)
        );

        // Если есть доступные корнизы, выбираем первую
        if (filteredCornice.length > 0 && !availableCornices.has(tkan2)) {
            tkan2 = filteredCornice[0];
        } else if (filteredCornice.length === 0) {
            tkan2 = '';
        }
    };

    const filterCorniceOptions2 = async () => {
        const data = await fetchData;

        if (!tkanboka || !data.tkanToCorniceMap) {
            // Если ничего не выбрано, показываем все корнизы
            filteredCornice2 = data.color_cornice || [];
            return;
        }

        // Получаем доступные корнизы для выбранной ткани
        const availableCornices = data.tkanToCorniceMap[tkanboka] || new Set();

        // Фильтруем опции корнизы
        filteredCornice2 = (data.color_cornice || []).filter(cornice =>
            availableCornices.has(cornice)
        );

        // Если есть доступные корнизы, выбираем первую
        if (filteredCornice2.length > 0 && !availableCornices.has(tkanboka2)) {
            tkanboka2 = filteredCornice2[0];
        } else if (filteredCornice2.length === 0) {
            tkanboka2 = '';
        }
    };

    const handle_type = (is_manual, dops) => {

        const hasManualOrWithout = tip.includes("Ручной") || tip.includes("без");
        if (!hasManualOrWithout) {
            t = "T3 (от центра)";
        } else if (!["T1 (к упр)", "T2 (от упр)", "T3 (от центра)", "T4 (к упр)"].includes(t)) {
            t = "T1 (к упр)";
        }

        components = {} // clean

        if (!is_manual) {
            let buf = dops.find((item) => item.name.trim().includes('Пульт'))

            components[buf.idTovar] = {count: 1}
        }
    }

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,
            w = +$width,
            h = +$height
        ;


        let result = {
            type: type,
            name: type,
            subname: [
                $width + 'x' + $height, tip, t, begunki, (kolvobok == 'нет' ? ' ' : ' основная  -') + tkan, tkan2, (kolvobok == 'нет' ? '' : kolvobok == 'Чередование' ? ' Чередование ' + tkanboka + ' ' + tkanboka2 : 'по бокам ' + kolvobok + ' боковая -' + tkanboka + ' ' + tkanboka2),
            ].join(', '),
            title: 'Жалюзи ' + type + ' ' + [
                $width + 'x' + $height, tip, t, begunki, (kolvobok == 'нет' ? ' ' : ' основная  -') + tkan, tkan2, (kolvobok == 'нет' ? '' : kolvobok == 'Чередование' ? ' Чередование ' + tkanboka + ' ' + tkanboka2 : 'по бокам ' + kolvobok + ' боковая -' + tkanboka + ' ' + tkanboka2),
            ].join(', '),
            params: {
                ind1: [(kolvobok == 'нет' ? ' ' : ' основная  -') + tkan, tkan2, (kolvobok == 'нет' ? '' : kolvobok == 'Чередование' ? ' Чередование ' + tkanboka + ' ' + tkanboka2 : 'по бокам ' + kolvobok + ' боковая -' + tkanboka + ' ' + tkanboka2)].join(', '),
                ind2: t,
                ind3: encode(JSON.stringify({
                    width: $width,
                    height: $height,
                    t,
                    kolvobok,
                    tip,
                    tkan,
                    tkan2,
                    tkanboka,
                    tkanboka2,
                    begunki,
                    components,
                    arcaVisotaBoka,
                    arcaVisotaCentr,
                    arca,
                    type
                })),
                ind4: w,
                ind5: h,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: options.vStrukture || 117
        };

        function ceilToEven(x) {
            return 2 * Math.ceil(x / 2);
        }

        let title_addons = []

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();
            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;
            if (name.includes("карниз вертикальный") && (tip == "ГИ Ручной лев" || tip == "ГИ Ручной прав.")) {
                kolvo =   w / 1000;

            }
            if (name.includes("электрокарниз вальс") && tip.toLowerCase().includes("эл.")) {
                kolvo = w / 1000;
            }
            if (name.includes("Мотор Novo 220 WIFI Вальс".toLowerCase()) && tip.includes("220В")) {
                kolvo = 1;
            }
            if (name.includes("Мотор Novo АКБ Вальс".toLowerCase()) && tip.includes("АКБ")) {
                kolvo = 1;
            }
            if (name.includes("Плечик".toLowerCase())) {

                if (type == "Вальс") {
                kolvo = Math.ceil(w / 110) * 2;
                }
                else{
                    kolvo = Math.ceil(w / 80)  ;
                }

            }
            if (name.includes("Дублерин (клейкая лента)".toLowerCase())) {
                kolvo = (w / 110 * 2 + 1) * 420 / 1000;
            }
            if (name.includes("кв.м".toLowerCase()) && tkan.includes(item.ind1) && !tip.includes('Карниз эл')) {





                if (begunki == 'Метал.бегунки' && name.includes("металл")) {

                    kolvo = (w * h / 1000000).toFixed(3);


                }

                if ((begunki != 'Метал.бегунки') && !name.includes("металл")) {

                    kolvo = (w * h / 1000000).toFixed(3);
                }


            }

            if (type == "Вальс" && name.includes("Ткань".toLowerCase()) && tkan == item.ind1 && tkan2 == item.ind2 && !tip.includes('Карниз эл')) {

                foto = item.foto_small;

                if (kolvobok === 'нет') {
                    if (t === 't3') {
                        kolvo = chetn($width / 110)
                    } else {
                        kolvo = ROUNDUP_TO_MULTIPLE($width / 110, 1)
                    }
                } else if (kolvobok === 'Чередование') {

                    if (t === 't3') {
                        kolvo = chetn($width / 110) / 2
                    } else {
                        kolvo = ROUNDUP_TO_MULTIPLE($width / 110, 1) / 2
                    }

                } else if (kolvobok.split('+')[0] === '0') {

                    if (t === 't3') {
                        kolvo = chetn($width / 110) - parseInt(kolvobok.split('+')[1], 10)
                    } else {
                        kolvo = ROUNDUP_TO_MULTIPLE($width / 110, 1) - parseInt(kolvobok.split('+')[1], 10)
                    }

                } else {
                    if (t === 't3') {
                        kolvo = chetn($width / 110) - 2 * parseInt(kolvobok.split('+')[0], 10)
                    } else {
                        kolvo = ROUNDUP_TO_MULTIPLE($width / 110, 1) - 2 * parseInt(kolvobok.split('+')[0], 10)
                    }
                }

                kolvo = kolvo * h / 1000;


            }
            if (type == "Вертикальные" && name.includes("Ткань".toLowerCase()) && tkan == item.ind1 && tkan2.toLowerCase() == item.ind2.toLowerCase()) {

                foto = item.foto_small;

                if (kolvobok === 'нет') {
                    if (t === 't3') {
                        kolvo = chetn($width / 90)
                    } else {
                        kolvo = ROUNDUP_TO_MULTIPLE($width / 90, 1)
                    }
                } else if (kolvobok === 'Чередование') {

                    if (t === 't3') {
                        kolvo = chetn($width / 90) / 2
                    } else {
                        kolvo = ROUNDUP_TO_MULTIPLE($width / 90, 1) / 2
                    }

                } else if (kolvobok.split('+')[0] === '0') {

                    if (t === 't3') {
                        kolvo = chetn($width / 90) - parseInt(kolvobok.split('+')[1], 10)
                    } else {
                        kolvo = ROUNDUP_TO_MULTIPLE($width / 90, 1) - parseInt(kolvobok.split('+')[1], 10)
                    }

                } else {
                    if (t === 't3') {
                        kolvo = chetn($width / 90) - 2 * parseInt(kolvobok.split('+')[0], 10)
                    } else {
                        kolvo = ROUNDUP_TO_MULTIPLE($width / 90, 1) - 2 * parseInt(kolvobok.split('+')[0], 10)
                    }
                }

                kolvo = kolvo * h / 1000;


            }
            if ((kolvobok != 'нет') && name.includes("Ткань".toLowerCase()) && tkanboka == item.ind1 && tkanboka2.toLowerCase() == item.ind2.toLowerCase() && !tip.includes('Карниз эл')) {

                foto = item.foto_small;

                if (kolvobok === 'Чередование') {

                    if (t === 't3') {
                        kolvo = chetn($width / 110) / 2
                    } else {
                        kolvo = ROUNDUP_TO_MULTIPLE($width / 110, 1) / 2
                    }

                } else if (kolvobok.split('+')[0] === '0') {
                    kolvo = parseInt(kolvobok.split('+')[1], 10)
                } else {
                    kolvo = 2 * parseInt(kolvobok.split('+')[0], 10)
                }
                kolvo = kolvo * h / 1000;
            }
            if (name.includes("Веревка для вертикалки".toLowerCase()) && (tip == "ГИ Ручной лев" || tip == "ГИ Ручной прав.")) {
                if (h * 2 - 850 >= 1600) {
                    kolvo = (w * 2 + h * 2 - 700) / 1000;
                } else {
                    kolvo = (w * 2 + h * 2) / 1000;
                }
            }
            if (name.includes("Нить".toLowerCase()) && (tip == "ГИ Ручной лев" || tip == "ГИ Ручной прав.")) {
                kolvo = (w * 2 + h * 2 - 850) / 1000;
            }
            if ((name.includes("Цепь металл".toLowerCase() && components.hasOwnProperty(91980)) && (tip == "ГИ Ручной лев" || tip == "ГИ Ручной прав.")) ||
                (name.includes("Цепь 5*6 пластик".toLowerCase()) && !components.hasOwnProperty(91980) )) {
                if (h * 2 - 850 >= 1600) {
                    kolvo = (h * 2 - 850) / 1000;
                } else {
                    kolvo = (1600) / 1000;
                }
            }
            if (name.includes("Цепь нижняя для вертикалки".toLowerCase())) {
                kolvo = (Math.ceil((w / 1000) * 2.5)).toFixed(3);
            }
            if ((name.includes("Кронштейны 110".toLowerCase()) || name.includes("Кронштейны 70".toLowerCase())) && (tip == "ГИ Ручной лев" || tip == "ГИ Ручной прав.")) {
                kolvo = (Math.ceil((w / 1000) / 0.5)).toFixed(3);
            }
            if (name.includes("Кронштейн потолочный".toLowerCase()) && (tip == "ГИ Ручной лев" || tip == "ГИ Ручной прав.")) {
                kolvo = (Math.ceil((w / 1000) / 0.5)).toFixed(3);
            }
            if (name.includes("Вес цепи".toLowerCase()) && (tip == "ГИ Ручной лев" || tip == "ГИ Ручной прав.")) {
                kolvo = 1;
            }
            if (name.includes("Груз веревки вертикалка".toLowerCase())) {
                kolvo = 1;
            }
            if (name.includes("Механизм вертикалка".toLowerCase())) {
                kolvo = 1;
            }
            if (name.includes("Кронштейн грувера".toLowerCase()) && components.hasOwnProperty(91986)) {
                kolvo = (Math.ceil(w / 500)).toFixed(3);
            }
            if (name.includes("Ткань на грувер".toLowerCase()) && components.hasOwnProperty(91986)) {
                kolvo = w / 1000;
            }

            if (name == 'Сборка системы вальс'.toLowerCase() || name == 'Изготовление вертикалка'.toLowerCase()) {
                kolvo = (1).toFixed(3);
            }

            if ((name == 'Изготовление арки'.toLowerCase())  && (arca =='Да'))  {
                kolvo = (1).toFixed(3);
            }

            if ((name.toLowerCase().includes("металлические бегунки") && begunki == 'Метал.бегунки') ||
                (name.toLowerCase().includes("бегунок") && tip.includes("Ручной") && begunki == 'Пласт.бегунки')) {

                if (type == "Вальс") {

                    const base = w / 110;

                    if (t.includes("T3") || t.includes("T4")) {
                        kolvo = ceilToEven(base) + 2;
                    } else if (t.includes("T1") || t.includes("T2")) {
                        kolvo = Math.ceil(base) + 1; // Math.ceil округляет вверх до целого
                    }
                }
                else{
                    const base = w / 80;

                    if (t.includes("T3") || t.includes("T4")) {
                        kolvo = ceilToEven(base) + 1;
                    } else if (t.includes("T1") || t.includes("T2")) {
                        kolvo = Math.ceil(base) ; // Math.ceil округляет вверх до целого
                    }
                }

            }

            if (components.hasOwnProperty(item.idTovar)) {
                let edIzmer = item.edIzmer.length ? item.edIzmer : 'шт.'

                if (item.name.toLowerCase().includes("грувер")) {
                    kolvo = Math.ceil(w / 1000);
                } else {
                    kolvo = +components[item.idTovar]['count'];
                }

                title_addons.push(`${item.name} - ${kolvo}/${edIzmer}`)
            }

            if (kolvo) {
                // Изменить расчёт на вальс, если выбрано "Ламели без карниза" - то от итоговой стоимость отнять 350 * площадь.
                if (name.includes("кв.м".toLowerCase()) && tip == "Ламели без карниза") {
                    price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price * (+item.flag) - kolvo * 350);
                    price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price * (+item.flag) - kolvo * 350);
                    price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);
                } else {
                    price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price * (+item.flag));
                    price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price * (+item.flag));
                    price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);
                }

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count:  +kolvo
                };
            }


        });

        if (title_addons.length > 0) {
            result.title = `${result.title} | ${title_addons.join(', ')}`;
        }

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        /*let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
        montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);
        dispatch('mounting', {item: montage_item, price: montage_price});*/


        dispatch('item', result);
    }, 250);

    // Инициализируем отфильтрованные значения после загрузки данных
    fetchData.then(() => {
        initializeFilteredValues();
    });

    change();


    function chetn(x) {
        // Округляем вверх до целого
        let c = Math.ceil(x);

        // Если число уже чётное — возвращаем его
        if (c % 2 === 0) {
            return c;
        }

        // Иначе возвращаем следующее чётное
        return c + 1;
    }

    function ROUNDUP_TO_MULTIPLE(value, multiple) {
        if (multiple === 0) return value;

        // Округляем до ближайшего кратного
        return Math.round(value / multiple) * multiple;
    }



    function ceilToEven(x) {
        return 2 * Math.ceil(x / 2);
    }
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    {@const is_manual = (tip.includes("Ручной") || tip.includes("Ламели"))}
    {@const dop_materials = type === 'Вальс' ?
        data.result.filter((item) => is_manual ? ['Грувер'].includes(item.name.trim()) : ['Кнопка для вальса А15', 'Пульт для вальса А13-6'].includes(item.name.trim()))
        :
        data.result.filter((item) => is_manual ? ['Грувер', 'Кронштейн Армстронг', 'Цепь металл'].includes(item.name.trim()) : ['Грувер', 'Кронштейн Армстронг', 'Цепь металл'].includes(item.name.trim()))
    }

    <style>

        .parentVertik {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-auto-rows: auto;
            grid-column-gap: 5px;
            grid-row-gap: 0px;
            grid-template-areas:
                    "type type"
                    "width hight"
                    "tip t"
                    "tkan tkan2"
                    "kolvobok kolvobok"
                    "tkanboka tkanboka2"
                    "arca ."
                    "arcaVisotaCentr arcaVisotaBoka"
                    "dopMaterial dopMaterial"
                    "comment comment "
                    "pict pict"
                    "pict pict"
                    "pict pict"
                    "pict pict";

        }

        .parentVals {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-auto-rows: auto;
            grid-column-gap: 5px;
            grid-row-gap: 0px;
            grid-template-areas:
                    "type type"
                    "info info"
                    "width hight"
                    "tip t"
                    "tkan tkan2"
                    "kolvobok kolvobok"
                    "tkanboka tkanboka2"
                    "begunki begunki"
                    "dopMaterial dopMaterial"
                    "comment comment "
                    "pict pict"
                    "pict pict"
                    "pict pict"
                    "pict pict";


        }

        @media (min-width: 575.98px) {
            .parentVals {
                grid-template-columns: repeat(4, 1fr);
                grid-template-areas:
                    "type type width hight"
                    "info info info info"
                    "pict pict tip t  "
                    "pict pict tkan tkan2 "
                    "pict pict kolvobok . "
                    "pict pict tkanboka tkanboka2"
                    "pict pict begunki begunki"
                    "dopMaterial dopMaterial dopMaterial dopMaterial"
                    "comment comment comment comment";
            }

            .parentVertik {
                grid-template-columns: repeat(4, 1fr);
                grid-template-areas:
                    "type type width hight"
                    "pict pict tip t  "
                    "pict pict tkan tkan2 "
                    "pict pict kolvobok . "
                    "pict pict tkanboka tkanboka2"
                    "pict pict arca ."
                    "pict pict arcaVisotaCentr arcaVisotaBoka"
                    "dopMaterial dopMaterial dopMaterial dopMaterial"
                    "comment comment comment comment";
            }
        }

        .arcaVisotaCentr {
            grid-area: arcaVisotaCentr;
        }

        .arcaVisotaBoka {
            grid-area: arcaVisotaBoka;
        }


        .arca {
            grid-area: arca;
        }

        .type {
            grid-area: type;
        }


        .info {
            grid-area: info;
        }


        /* Шир*/
        .div1 {
            grid-area: width;
        }

        /*  Выс*/
        .div2 {
            grid-area: hight;
        }

        /*      Тип, комплектация*/
        .div3 {
            grid-area: tip;
        }

        /*T1*/
        .div4 {
            grid-area: t;
        }

        /*    Ткань основа*/
        .div5 {
            grid-area: tkan
        }

        /*  Ткань основа*/
        .div6 {
            grid-area: tkan2;
        }

        /*  Количество ламелей*/
        .div7 {
            grid-area: kolvobok;
        }

        /*   Ткань бока*/
        .div8 {
            grid-area: tkanboka;
        }

        /*   Ткань бока*/
        .div9 {
            grid-area: tkanboka2;
        }

        /* pict */
        .div10 {
            grid-area: pict
        }

        /* примечание */
        .div11 {
            grid-area: comment;
        }


        .div12 {
            grid-area: dopMaterial;
        }

        .div10 {
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }

        .begunki {
            grid-area: begunki
        }


        .div10 .pict {
            align-items: center;
            justify-content: center;
            overflow: hidden;
            background-image: var(--var-picture);
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
            height: calc(100% - 60px);
            width: 100%;
        }


    </style>
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row d-flex">
            <div class="col-12  ">
                <div class="row">
                    <span class="badge-danger text-white small rounded-2 text-center text-uppercase"> { ($width > (options.recomend && options.recomend.width ? options.recomend.width : 4500) || $height > (options.recomend && options.recomend.height ? options.recomend.height : 6000)) ? 'Изделие с данным размером не подлежит гарантии' : '' }</span>
                </div>
                <div class={type === 'Вальс'? 'parentVals' : 'parentVertik' }>

                    <div class="type d-none" >
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип</label>
                                <select class="form-control form-select" bind:value={type} on:change={changeType}>
                                    <option value="Вальс">Вальс</option>
                                    <option value="Вертикальные">Вертикальные</option>
                                </select>
                            </div>
                        </div>
                    </div>


                    <div class="info {type === 'Вальс'? '' : 'd-none' }">
                        <div class="alert alert-outline-danger">
                            По умолчанию используются бегунки от вертикальных жалюзи, металические бегунки можно
                            добавить внизу
                        </div>
                    </div>


                    <div class="div1 form-group boxed">
                        <div class="input-wrapper">

                            <label class="form-label">300≥Шир.,мм ≥6000</label>
                            <input type="number"
                                   class="form-control text-center  "
                                   step="1"
                                   min="300"
                                   max="6000"
                                   bind:value={$width} use:validate_int={$width}>
                        </div>
                    </div>

                    <div class="div2 form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">300≥Выс.,мм≥6000</label>
                            <input type="number"
                                   class="form-control text-center "
                                   step="1"
                                   min="300"
                                   max="6000"
                                   bind:value={$height} use:validate_int={$height}>
                        </div>
                    </div>


                    {#if type === 'Вертикальные'}

                        <div class="arca">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Арка </label>
                                    <select class="form-control form-select" bind:value={arca}>
                                        <option value="Да">Да</option>
                                        <option value="Нет">Нет</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                    {/if}
                    {#if type === 'Вальс'}

                        <div class="begunki">
                            <div class="input-wrapper">
                                <label class="form-label">Бегунки</label>
                                <select class="form-control form-select" bind:value={begunki}>
                                    <option value="Пласт.бегунки">Пластмассовые бегунки</option>
                                    <option value="Метал.бегунки">Металлические бегунки</option>
                                </select>
                            </div>
                        </div>

                    {/if}


                    {#if type === 'Вертикальные' && arca == 'Да'}

                        <div class="arcaVisotaCentr form-group boxed">
                            <div class="input-wrapper">

                                <label class="form-label">Высота центр</label>
                                <input type="number"
                                       class="form-control text-center  "
                                       step="1"
                                       min="0"
                                       max="4500"
                                       bind:value={arcaVisotaCentr} use:validate_int={arcaVisotaCentr}>
                            </div>
                        </div>

                        <div class="arcaVisotaBoka form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Высота бока</label>
                                <input type="number"
                                       class="form-control text-center "
                                       step="1"
                                       min="0"
                                       max="6000"
                                       bind:value={arcaVisotaBoka} use:validate_int={arcaVisotaBoka}>
                            </div>
                        </div>

                    {/if}

                    <div class="div3 form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Тип, комплектация</label>
                            <select class="form-control form-select" bind:value={tip}
                                    on:change={() => handle_type(is_manual, dop_materials)}>

                                {#if type === 'Вальс'}
                                    <option value="ГИ Ручной лев">ГИ Ручной лев</option>
                                    <option value="ГИ Ручной прав.">ГИ Ручной прав.</option>
                                    <option value="Ламели без карниза">Ламели без карниза</option>
                                    <option value="ГИ Эл. 220В Wi-Fi лев">ГИ Эл. 220В Wi-Fi лев</option>
                                    <option value="ГИ Эл. АКБ лев">ГИ Эл. АКБ лев</option>
                                    <option value="Карниз эл. 220В Wi-Fi лев">Карниз эл. 220В Wi-Fi лев</option>
                                    <option value="Карниз эл. АКБ лев">Карниз эл. АКБ лев</option>
                                {:else}
                                    <option value="ГИ Ручной лев">ГИ Ручной лев</option>
                                    <option value="ГИ Ручной прав.">ГИ Ручной прав.</option>
                                    <option value="Только карниз">Только карниз</option>
                                    <option value="Только ламели">Только ламели</option>
                                {/if}

                            </select>
                        </div>
                    </div>


                    <div class="div4 form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label text-white">_ </label>
                            <select class="form-control form-select" bind:value={t}>
                                {#if tip.includes("Ручной") || tip.includes("без")}
                                    <option value="T1 (к упр)">T1 (к упр)</option>
                                    <option value="T2 (от упр)">Т2 (от упр)</option>
                                {/if}
                                <option value="T3 (от центра)">Т3 (от центра)</option>
                                {#if tip.includes("Ручной") || tip.includes("без")}
                                    <option value="T4 (к упр)">T4 (к центру)</option>

                                {/if}
                            </select>
                        </div>
                    </div>


                    <div class="div5 form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Ткань основа:</label>
                            <select class="form-control form-select" bind:value={tkan} on:change={handleTkanChange}>
                                {#each data.color_tape as value}
                                    <option value="{value}">{value}</option>
                                {/each}
                            </select>
                        </div>
                    </div>


                    <div class="div6 form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label text-white">_</label>
                            <select class="form-control form-select" bind:value={tkan2}>
                                {#each filteredCornice as value}
                                    <option value="{value}">{value}</option>
                                {/each}
                            </select>
                        </div>
                    </div>


                    <div class="div7 form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Кол-во по бокам / Чередование</label>
                            <select class="form-control form-select" bind:value={kolvobok}>
                                <option value="нет">нет</option>
                                <option value="2+2">2+2</option>
                                <option value="3+3">3+3</option>
                                <option value="4+4">4+4</option>
                                <option value="5+5">5+5</option>
                                <option value="6+6">6+6</option>
                                <option value="7+7">7+7</option>
                                <option value="8+8">8+8</option>
                                <option value="0+2">0+2</option>
                                <option value="0+3">0+3</option>
                                <option value="0+4">0+4</option>
                                <option value="0+5">0+5</option>
                                <option value="0+6">0+6</option>
                                <option value="0+7">0+7</option>
                                <option value="0+8">0+8</option>
                                <option value="Чередование">Чередование</option>
                            </select>
                        </div>
                    </div>

                    {#if kolvobok !== 'нет'}

                        <div class="div8 form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">
                                    {#if kolvobok !== 'Чередование'} Ткань бока:{:else} Ткань чередования:{/if}
                                </label>
                                <select class="form-control form-select" bind:value={tkanboka}
                                        on:change={handleTkan2Change}>
                                    {#each data.color_tape as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>

                        </div>

                        <div class="div9 form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label text-white">_ </label>
                                <select class="form-control form-select" bind:value={tkanboka2}>
                                    {#each filteredCornice2 as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>

                    {/if}


                    <div class="div10 form-group boxed d-flex flex-column justify-content-center align-items-center">


                        <div>

                            <img style="width: 100%;max-width: 300px;max-height: 300px;" src="{`/img/other/vals/${
      // Определяем реальное значение kolvobok для подстановки в путь
      (() => {
        // Проверяем, является ли kolvobok одним из значений, которые нужно заменить
        if (kolvobok === '4+4' || kolvobok === '5+5' || kolvobok === '6+6' || kolvobok === '7+7' || kolvobok === '8+8') {
          return '3+3'; // Заменяем на 3+3
        }
        if (kolvobok === '0+4' || kolvobok === '0+5' || kolvobok === '0+6' || kolvobok === '0+7' || kolvobok === '0+8') {
          return '0+3'; // Заменяем на 0+3
        }
        // Для остальных возвращаем значение как есть, но в нижнем регистре
        // Учитываем, что kolvobok может быть null/undefined
        return (kolvobok || 'нет').toLowerCase();
      })()
    }_${t.substring(0, 2).toLowerCase()}${ tip.includes('прав') ? '_r': ''}.png`}">
                        </div>

                        <div class="d-flex col-12">

                            <div class="text-center col-4">
                                {#if kolvobok === 'нет' || kolvobok === 'Чередование'}

                                {:else}
                                    { parseInt(kolvobok.split('+')[0], 10)} шт.
                                {/if}
                            </div>

                            <div class="text-center col-4">


                                {#if kolvobok === 'нет' || kolvobok === 'Чередование'}

                                    {#if (type == "Вальс") }
                                        {#if t.includes('T3') || t.includes('T4')}
                                            {#if (tip.toLowerCase().includes('эл.'))}
                                                { ceilToEven($width / 105) } шт.
                                            {:else}
                                                { ceilToEven($width / 110) } шт.
                                            {/if}
                                        {:else}
                                            {#if (tip.toLowerCase().includes('эл.'))}
                                                { Math.ceil($width / 105) } шт.
                                            {:else}
                                                { Math.ceil($width / 110) } шт.
                                            {/if}
                                        {/if}
                                    {:else}
                                        {#if t.includes('T3') || t.includes('T4')}
                                            { ceilToEven($width / 80) } шт.
                                        {:else}
                                            { Math.ceil($width / 80) } шт.
                                        {/if}
                                    {/if}
                                {:else}
                                    {#if t.includes('T3') || t.includes('T4')}
                                        { ceilToEven($width / 110) - parseInt(kolvobok.split('+')[0], 10) - parseInt(kolvobok.split('+')[1], 10) } шт.
                                    {:else}
                                        { Math.ceil($width / 110) - parseInt(kolvobok.split('+')[0], 10) - parseInt(kolvobok.split('+')[1], 10) } шт.
                                    {/if}
                                {/if}

                            </div>
                            <div class="text-center col-4 ">
                                {#if kolvobok === 'нет' || kolvobok === 'Чередование'}

                                {:else}
                                    { parseInt(kolvobok.split('+')[1], 10)} шт.
                                {/if}
                            </div>
                        </div>


                    </div>


                    <div class="div12">
                        <DopMaterialList list={dop_materials} bind:components={components}/>
                    </div>

                    <div class="div11 form-group boxed">
                        <div class="input-wrapper">
                            <div class="input-wrapper">
                                <label class="form-label">Примечание</label>
                                <textarea class="form-control" bind:value={$comment}></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
{/await}
